<div class="time-picker">
  <div class="active-time-container">
    <ng-container *ngIf="hour <= 9">0</ng-container>{{hour}}:<ng-container *ngIf="minute <= 9">0</ng-container>{{minute}}
  </div>

  <div class="w-clock-wrapper" fxLayout="row" fxLayoutAlign="center center">
    <div class="w-clock">
      <div class="w-clock-container">

        <!-- Clock center -->
        <button [color]="color" class="w-clock-center" mat-mini-fab></button>

        <!-- Hour / Minute number faces -->
        <ng-container *ngIf="currentView === 1">
          <div class="subcontainer">
            <mat-toolbar [color]="color" [ngStyle]="getPointerStyle('outer')" class="w-pointer">
              <button [color]="color" class="w-clock-selected" mat-mini-fab></button>
            </mat-toolbar>

            <div *ngFor="let step of [1,2,3,4,5,6,7,8,9,10,11,12]; let i = index" [class]="getTimeValueClass(step, i)">
              <button (click)="changeTimeValue(step)" [color]="selectedTimePart === step ? color : ''" mat-mini-fab>
                {{ step }}
              </button>
            </div>
          </div>

          <div class="subcontainer inner">
            <mat-toolbar [color]="color" [ngStyle]="getPointerStyle('inner')" class="w-pointer">
              <button [color]="color" class="w-clock-selected" mat-mini-fab></button>
            </mat-toolbar>

            <div *ngFor="let step of [13,14,15,16,17,18,19,20,21,22,23,24]; let i = index" [class]="getTimeValueClass(step, i)">
              <button (click)="changeTimeValue(step)" [color]="selectedTimePart === step ? color : ''" mat-mini-fab>
                {{ step }}
              </button>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="currentView === 2">
          <div class="subcontainer">
            <mat-toolbar [color]="color" [ngStyle]="getPointerStyle('outer')" class="w-pointer">
              <button [color]="color" class="w-clock-selected" mat-mini-fab></button>
            </mat-toolbar>

            <div *ngFor="let step of [0,5,10,15,20,25,30,35,40,45,50,55]; let i = index" [class]="getTimeValueClass(step, i)">
              <button (click)="changeTimeValue(step)" [color]="selectedTimePart === step ? color : ''" mat-mini-fab>
                {{ step }}
              </button>
            </div>
          </div>
        </ng-container>

      </div>
    </div>
  </div>

  <div class="button-right-container">
    <button (click)="cancel()" class="ibexfusion-raised-button" mat-button>Abbrechen</button>
    <button (click)="save()" class="ibexfusion-raised-button" mat-button>OK</button>
  </div>

</div>
